<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">

        <b-button block v-b-toggle.privacy-section-9
          class="text-left fw-500 d-flex align-items-center justify-content-between">
              <div>
                  <span class="box-numbering">09</span>
                  <span>Changes to This Privacy Policy</span>    
              </div>
              <span 
                  class="toggle-icon" 
                  :class="{ active: isOpen }"
              >
                  <span class="plus">+</span>
                  <span class="cross">×</span>
              </span> 
          </b-button>

      </b-card-header>
      <b-collapse
        id="privacy-section-9"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Changes to This Privacy Policy We may update this Privacy Policy
            from time to time. Any changes will be posted on our website, and
            the updated policy will take effect as of the effective date
            indicated.
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "section-9",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
